/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
// ===
/* eslint no-else-return: "error" */
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
import BookOnlineOutlinedIcon from '@mui/icons-material/BookOnlineOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import EventBusyOutlinedIcon from '@mui/icons-material/EventBusyOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import MarkunreadOutlinedIcon from '@mui/icons-material/MarkunreadOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { DoorbellOutlined } from '@mui/icons-material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined';
import DynamicFormOutlinedIcon from '@mui/icons-material/DynamicFormOutlined';
// import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import BugReportIcon from '@mui/icons-material/BugReport';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import DescriptionIcon from '@mui/icons-material/Description';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined'; import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import { IMAGE_URL } from '../utils/config';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import { axios } from '../utils/axios';
import SvgColor from '../components/svg-color';

const MyContext = createContext();

// Create a provider component
const colorDemo = "#1f2937"
const icon = (name) => (
  <SvgColor src={`${IMAGE_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

export const MyProvider = ({ children, i18 }) => {
  const [myValue, setMyValue] = useState('Default Value');
  const [imageUrl, setImageUrl] = useState('Default Value');
  const [data, setData] = useState({});
  const [logo, setLogo] = useState();
  const [logoUrl, setLogoUrl] = useState();
  const [favicon, setFavicon] = useState();
  const [settingsData, setSettingsData] = useState();
  const [demoMode, setDemoMode] = useState();
  const [documentsMode, setDocumentsMode] = useState();
  const [baseUrl, setBaseUrl] = useState();
  const [state, setState] = useState(false);
  const [map, setMap] = useState('');
  const [specification, setSpecification] = useState();
  const [addition, setAddition] = useState("");
  const [formatDate, setFormatDate] = useState();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [propertyId, setPropertyId] = useState('');
  const [widgetId, setWidgetId] = useState('');
  const [adsMode, setAdsMode] = useState('');
  const [primaryTheme, setPrimaryTheme] = useState('');
  const [secondaryTheme, setSecondaryTheme] = useState('');
  const [getAvailableCount, setAvailableCount] = useState('');

  const checkAuth = () => {
    const token = localStorage.getItem("admintoken");
    if (token) {
      setIsAuthenticated(true)
    } else {
      setIsAuthenticated(false)
    }
  }

  const fetchProfileData = async () => {
    try {
      const res = await axios.get('module/auth/admin/profile');
      if (res.status === 200) {
        const profileData = res?.data?.data?.profileData;
        if (Array.isArray(profileData?.role?.permission)) {

          profileData.roles = profileData?.role?.permission?.filter((item) => item.status).map((item) => (item.menu));
          // console.log('profiledataa',profileData.roles)
        } else {
          profileData.roles = [];
        }
        setMyValue(profileData);
        setImageUrl(res?.data?.data?.profileData.profileImage);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const settingGetData = async () => {
    try {
      const res = await axios.get('module/settings');
      // console.log(res, 'context');

      if (res.status === 200) {
        setData(res.data.data);
        setLogo(res.data.data.app.logo);
        setFavicon(res.data.data.app.favicon);
        setSettingsData(res.data.data.hiddenSettings.sensitive);
        setMap(res.data.data.google.mapApiKey);
        setBaseUrl(res.data.data.app.baseurl);
        setLogoUrl(res.data.data.baseUrl);
        setDemoMode(res.data.data.hiddenSettings.mode);
        setFormatDate(res.data.data.hiddenSettings.dateFormat);
        setSpecification(res.data.data.listings.specifications);
        setAddition(res.data.data.listings.pricings.additions);
        setDocumentsMode(res.data.data.hiddenSettings.documentVerification);
        setPropertyId(res.data.data.chat.chatPropertyId);
        setWidgetId(res.data.data.chat.chatWidgetId);
        setAdsMode(res?.data?.data?.hiddenSettings?.ads);
        setSecondaryTheme(res?.data?.data?.theme?.secondaryTheme);
        setPrimaryTheme(res?.data?.data?.theme?.primaryTheme);
        setAvailableCount(res?.data?.data?.listings?.availableCount)
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    checkAuth();
    if (isAuthenticated) {
      fetchProfileData();
    }
    settingGetData();
  }, [isAuthenticated]);

  // ===
  const [apiData, setApiData] = useState([]);

  const navConfig = useMemo(() => [
    {
      isHeader: true,
      title: i18?.SIDEBAR?.ACCOUNTS || "Accounts",

      name: ['Admin', 'Admin Roles', 'User']
    },
    // {
    //   path: '/dashboard',
    //   urls: ['/dashboard/editprofile', '/dashboard/AdminProfile','/dashboard']
    // },
    {

      title: i18?.SIDEBAR?.ADMIN || "Admin",
      path: '/dashboard/admin',
      name: 'Admin',
      icon: <AdminPanelSettingsOutlinedIcon sx={{ color: colorDemo }} />,
      urls: ['/dashboard/admin', '/dashboard/editadmin', '/dashboard/addprofile', '/dashboard/adminRoles']
    },
    {
      title: i18?.SIDEBAR?.ADMINROLES || "Admin Roles",
      path: '/dashboard/adminroles',
      icon: <SecurityOutlinedIcon sx={{ color: colorDemo }} />,
      name: 'Admin Roles',
      urls: ['/dashboard/adminroles', '/dashboard/adminRolesForm', '/dashboard/adminRolesForm?adminRoleId']
    },
    {
      title: i18?.SIDEBAR?.USER || "User",
      path: '/dashboard/user',
      // icon: icon('ic_user'),
      icon: <AccountCircleOutlinedIcon sx={{ color: colorDemo }} />,
      name: 'User',
      urls: ['/dashboard/user', '/dashboard/addprofile', '/dashboard/edituser']
    },
    {
      isdivider: true,
    },

    {
      isHeader: true,
      title: i18?.SIDEBAR?.LISTINGS || "Listings",
      for: ['listing'],
      name: ['Listings', 'Commission & Tax', 'FORMMANGEMENT'],
    },
    // {
    //   // title: '',
    //   path: '/dashboard/listing',
    //   // icon: icon('ic_admin'),
    //   icon: <ListOutlinedIcon sx={{ color: colorDemo }} />,
    //   title: i18?.SIDEBAR?.LISTING || "Listing",
    //   options: [
    //     {

    //       title: i18?.SIDEBAR?.LISTING || "Listing",
    //       path: '/dashboard/listing',
    //       // icon: icon('ic_list'),
    //       icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
    //     },
    //     {

    //       title: i18?.SIDEBAR?.RULES_ICONS || "Rules icons",
    //       path: '/dashboard/icon',
    //       // icon: icon('ic_icon'),
    //       icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
    //     },
    //   ],
    // },
    // {

    //   title: i18?.SIDEBAR?.LIST_AMENITY || "List Amenity",
    //   path: '/dashboard/amenitycategory',
    //   // icon: icon('ic_amenity'),
    //   icon: <DomainAddOutlinedIcon sx={{ color: colorDemo }} />,
    // },
    {

      path: '/dashboard/listing',
      title: i18?.SIDEBAR?.LISTING || "Listing",
      // icon: icon('ic_cate'),
      icon: <ListOutlinedIcon sx={{ color: colorDemo }} />,
      for: ['listing'],
      name: 'Listing',
      urls: ['/dashboard/listing', '/dashboard/editlisting', '/dashboard/addListing']
      // optionTitle: 'Manage Trips',
      // options: [
      //   {
      //     title: 'Current Trip',
      //     path: '/dashboard/currenttrips',
      //     icon: icon('ic_analytics'),
      //   },
      //   {
      //     title: 'Upcoming Trip',
      //     path: '/dashboard/upcomingtrips',
      //     icon: icon('ic_analytics'),
      //   },
      // ],
    },
    {
      title: i18?.SIDEBAR?.COMMISSION_TAX || "Commission & Tax",
      path: '/dashboard/commission',
      // icon: icon('ic_tax'),
      icon: <ReceiptOutlinedIcon sx={{ color: colorDemo }} />,
      for: ['listing'],
      name: 'Commission & Tax',
      urls: ['/dashboard/commission']
    },
    {
      title: i18?.SIDEBAR?.FORM_MANAGEMENT || "Form Management",
      path: '/dashboard/FormManagement',
      icon: <DynamicFormOutlinedIcon sx={{ color: colorDemo }} />,
      for: ['listing'],
      name: 'Form Management',
      urls: ['/dashboard/FormManagement']
    },
    {
      isdivider: true,
      for: ['listing']
    },
    {
      isHeader: true,
      title: i18?.SIDEBAR?.BOOKINGS || "Bookings",
      for: ['listing'],
      name: ['Pending Booking', 'Accepted Booking', 'Cancellation History', 'Booking History']
    },
    // {
    //   // title: '',
    //   optionTitle: i18?.SIDEBAR?.MANAGE_BOOKINGS || "Manage Bookings",
    //   icon: <BookOnlineOutlinedIcon sx={{ color: colorDemo }} />,
    //   options: [
    //     {
    //       title: i18?.SIDEBAR?.PENDING_BOOKINGS || "Pending Booking",
    //       path: '/dashboard/pendingbooking',
    //       // icon: icon('ic_pending'),
    //       icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
    //     },
    //     {
    //       title: i18?.SIDEBAR?.ACCEPTED_BOOKINGS || "Accepted Booking",
    //       path: '/dashboard/acceptedbooking',
    //       // icon: icon('ic_accept'),
    //       icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
    //     },

    //     {
    //       title: i18?.SIDEBAR?.CANCELLATION_HISTORY || "Cancellation History",
    //       path: '/dashboard/cancellationhistory',
    //       // icon: icon('ic_cancel'),
    //       icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
    //     },
    //   ],
    // },
    {
      title: i18?.SIDEBAR?.PENDING_BOOKINGS || "Pending Booking",
      path: '/dashboard/pendingbooking',
      // icon: icon('ic_history'),
      icon: <PendingActionsOutlinedIcon sx={{ color: colorDemo }} />,
      for: ['listing'],
      name: 'Pending Booking',
      urls: ['/dashboard/pendingbooking']
    },
    {
      title: i18?.SIDEBAR?.ACCEPTED_BOOKINGS || "Accepted Booking",
      path: '/dashboard/acceptedbooking',
      // icon: icon('ic_history'),
      icon: <EventAvailableOutlinedIcon sx={{ color: colorDemo }} />,
      for: ['listing'],
      name: 'Accepted Booking',
      urls: ['/dashboard/acceptedbooking']
    },
    {
      title: i18?.SIDEBAR?.CANCELLATION_HISTORY || "Cancellation History",
      path: '/dashboard/cancellationhistory',
      // icon: icon('ic_history'),
      icon: <EventBusyOutlinedIcon sx={{ color: colorDemo }} />,
      for: ['listing'],
      name: 'Cancellation History',
      urls: ['/dashboard/cancellationhistory']
    },
    {
      title: i18?.SIDEBAR?.BOOKING_HISTORY || "Booking History",
      path: '/dashboard/bookinghistory',
      // icon: icon('ic_history'),
      icon: <HistoryOutlinedIcon sx={{ color: colorDemo }} />,
      for: ['listing'],
      name: 'Booking History',
      urls: ['/dashboard/bookinghistory']
    },
    {
      isdivider: true,
      for: ['listing']
    },
    {
      isHeader: true,
      title: i18?.SIDEBAR?.THEME_MANAGEMENT || "Theme Management",
      for: ['listing'],
      name: ['Themes']
    },
    {
      title: i18?.SIDEBAR?.THEME || "Themes",
      path: '/dashboard/themeManagement',
      icon: <RateReviewOutlinedIcon sx={{ color: colorDemo }} />,
      for: ['listing'],
      name: 'Themes',
      urls: ['/dashboard/themeManagement']
    },

    {
      isHeader: true,
      title: i18?.SIDEBAR?.REVIEW_MANAGEMENT || "Review Management",
      for: ['listing'],
      name: ['Review Management']
    },
    {
      title: i18?.SIDEBAR?.REVIEW_MANAGEMENT || "Review Management",
      path: '/dashboard/reviewmanagement',
      icon: <RateReviewOutlinedIcon sx={{ color: colorDemo }} />,
      for: ['listing'],
      name: 'Review Management',
      urls: ['/dashboard/reviewAdminReplies', '/dashboard/reviewmanagement', '/dashboard/reviewManagement']
    },
    {
      isdivider: true,
      for: ['listing'],
    },


    {
      isHeader: true,
      title: i18?.SIDEBAR?.ADVERTISEMENT || "Advertisement",
      for: ['ads'],
      name: ['Ads', 'Category', 'Form Management']
    },
    {
      title: i18?.SIDEBAR?.LISTINGS || "Listings",
      path: '/dashboard/ads-listing',
      icon: <WidgetsOutlinedIcon sx={{ color: colorDemo }} />,
      for: ['ads'],
      name: 'Ads',
      urls: ['/dashboard/ads-listing']
    },
    {
      title: i18?.SIDEBAR?.CATEGORY || "Category",
      path: '/dashboard/category&subcategory',
      icon: <WidgetsOutlinedIcon sx={{ color: colorDemo }} />,
      for: ['ads'],
      name: 'Category',
      urls: ['/dashboard/category&subcategory']
    },
    {
      title: i18?.SIDEBAR?.FORM_MANAGEMENT || "Form Management",
      path: '/dashboard/adFormManagement',
      icon: <DynamicFormOutlinedIcon sx={{ color: colorDemo }} />,
      for: ['ads'],
      name: 'Form Management',
      urls: ['/dashboard/adFormManagement']
    },
    {
      isdivider: true,
      for: ['ads']
    },
    {
      isHeader: true,
      title: i18?.SIDEBAR?.EARNINGS || "Earnings",
      for: ['listing'],
      name: ['Earnings Report']
    },
    {
      title: i18?.SIDEBAR?.EARNINGS_REPORT || "Earnings Report",
      path: '/dashboard/EarningsReport',
      icon: <AttachMoneyIcon sx={{ color: colorDemo }} />,
      for: ['listing'],
      name: 'Earnings Report',
      urls: ['/dashboard/EarningsReport']
    },
    {
      isdivider: true,
      for: ['listing']
    },
    {
      isHeader: true,
      title: i18?.SIDEBAR?.SETTINGS || "Settings",
      name: ['Utility', 'Gallery', 'Report Listing', 'Package Subscriptions', 'Report User', 'Settings', 'Email Template', "Push Notification Template", 'CMS',]
    },
    {
      // title: '',
      optionTitle: i18?.SIDEBAR?.UTILITY || "Utility",
      icon: <BookOnlineOutlinedIcon sx={{ color: colorDemo }} />,
      name: 'Utility',
      options: [
        {
          title: i18?.SIDEBAR?.RULES_ICONS || "Rules Icons",
          path: '/dashboard/icon',
          // icon: icon('ic_icon'),
          icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
          for: ['listing'],
          urls: ['/dashboard/addicon', '/dashboard/icon']
        },
        // {

        //   title: i18?.SIDEBAR?.LIST_AMENITY || "List Amenity",
        //   path: '/dashboard/amenitycategory',
        //   // icon: icon('ic_amenity'),
        //   icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
        //   urls: ['/dashboard/addamenity', '/dashboard/amenitycategory', '/dashboard/amenityCategory']
        // },
        {
          title: i18?.SIDEBAR?.LIST_CATEGORY || "List Category",
          path: '/dashboard/category',
          // icon: icon('ic_cate'),
          icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
          for: ['listing'],
          urls: ['/dashboard/category', '/dashboard/addamenity', '/dashboard/property', '/dashboard/EditCategory']
        },
      ],
    },


    // {
    //   path: '/dashboard/privilege',
    //   optionTitle: i18?.SIDEBAR?.PRIVILEGE || "Privileges",
    //   icon: <BookOnlineOutlinedIcon sx={{ color: colorDemo }} />,
    //   options: [
    //     {

    //       title: i18?.SIDEBAR?.RULES_ICONS || "Rules icons",
    //       path: '/dashboard/icon',
    //       // icon: icon('ic_icon'),
    //       icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
    //     },
    //     {

    //       title: i18?.SIDEBAR?.LIST_PRIVILEGES || "List Privileges",
    //       path: '/dashboard/privilegecategory',
    //       // icon: icon('ic_amenity'),
    //       icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
    //     },
    //     {
    //       title: i18?.SIDEBAR?.LIST_CATEGORY || "List Category",
    //       path: '/dashboard/category',
    //       // icon: icon('ic_cate'),
    //       icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
    //     },
    //   ],
    // },
    {
      title: i18?.SIDEBAR?.PRIVILEGE || "Privileges",
      icon: <LockOutlinedIcon sx={{ color: colorDemo }} />,
      path: '/dashboard/privilegecategory',
      name: 'Privileges'
    },
    {
      // title: '',
      path: '/dashboard/admin',
      // icon: icon('ic_admin'),
      icon: <TranslateOutlinedIcon sx={{ color: colorDemo }} />,
      optionTitle: i18?.SIDEBAR?.TRANSLATE || "Translate",
      name: 'Translate',
      options: [
        {
          title: i18?.SIDEBAR?.LANGUAGES || "Languages",
          path: '/dashboard/language',
          // icon: icon('ic_lang'),
          icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
          url: ['/dashboard/language']
        },
        {
          title: i18?.SIDEBAR?.TRANSLATIONS || "Translations",
          path: '/dashboard/translations',
          // icon: icon('ic_translate'),
          icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
          urls: ['/dashboard/translations']
        },
      ],
    },

    // {
    //   title: 'List Amenity',
    //   path: '/dashboard/amenitycategory',
    //   // icon: icon('ic_amenity'),
    //   icon:<DomainAddOutlinedIcon sx={{color:colorDemo}}/>,
    // },
    // {
    //   title: 'List Category',
    //   path: '/dashboard/category',
    //   // icon: icon('ic_cate'),
    //   icon:<CategoryOutlinedIcon sx={{color:colorDemo}}/>,
    //   // optionTitle: 'Manage Trips',
    //   // options: [
    //   //   {
    //   //     title: 'Current Trip',
    //   //     path: '/dashboard/currenttrips',
    //   //     icon: icon('ic_analytics'),
    //   //   },
    //   //   {
    //   //     title: 'Upcoming Trip',
    //   //     path: '/dashboard/upcomingtrips',
    //   //     icon: icon('ic_analytics'),
    //   //   },
    //   // ],
    // },

    // {
    //   title: 'Transaction History',
    //   path: '/dashboard/TransactionHistory',
    //   icon: icon('ic_user'),
    // },

    {
      title: i18?.SIDEBAR?.OFFERS || "Offers",
      path: '/dashboard/offers',
      icon: <LocalOfferOutlinedIcon sx={{ color: colorDemo, }} />,
      for: ['listing'],
      name: 'Offers',
      urls: ['/dashboard/offers']
    },
    {
      optionTitle: i18?.SIDEBAR?.ADS_SUBSCRIPTION || "Ads Subscription",
      icon: <MonetizationOnIcon sx={{ color: colorDemo }} />, // Represents pricing or subscription
      name: 'Package Subscriptions',
      options: [
        {
          title: i18?.SIDEBAR?.PACKAGES || "Packages",
          path: '/dashboard/packagesList',
          icon: <DescriptionIcon sx={{ color: colorDemo }} />,
          for: ['ads'],
          urls: ['/dashboard/packagesForm', '/dashboard/packagesList']
        },
      ],
      for: ['ads']
    },
    {
      title: i18?.SIDEBAR?.GALLERY_SECTION || "Gallery",
      path: '/dashboard/Gallery',
      icon: <PhotoLibraryIcon sx={{ color: colorDemo }} />,
      name: 'Gallery',
      urls: ['/dashboard/addGallery', '/dashboard/editGallery', '/dashboard/addImages', '/dashboard/gallery', 'How does it work']
    },
    {
      optionTitle: i18?.SIDEBAR?.LISTING_REPORT || "Report Listing",
      icon: <ReportProblemIcon sx={{ color: colorDemo }} />,
      name: 'Report Listing',
      options: [
        {
          title: i18?.SIDEBAR?.REPORT_TEMPLATE || "Report Template",
          path: '/dashboard/Report',
          icon: <DescriptionIcon sx={{ color: colorDemo }} />,
          for: ['listing'],
          urls: ['/dashboard/reportForm', '/dashboard/Report']
        },
        {
          title: i18?.SIDEBAR?.USER_REPORT || "User Report",
          path: '/dashboard/UserReport',
          icon: <BugReportIcon sx={{ color: colorDemo }} />,
          for: ['listing'],
          urls: ['/dashboard/UserReport', '/dashboard/editUserReport']
        },
      ],
      for: ['listing']
    },
    {
      optionTitle: i18?.SIDEBAR?.USER_REPORT || "Report User",
      icon: <ErrorOutlineIcon sx={{ color: colorDemo }} />,
      name: 'Report User',
      options: [
        {
          title: i18?.SIDEBAR?.REPORT_TEMPLATE || "Report Template",
          path: '/dashboard/reportUser',
          icon: <DescriptionIcon sx={{ color: colorDemo }} />,
          for: ['ads'],
          urls: ['/dashboard/reportUserForm', '/dashboard/reportUser']
        },
        {
          title: i18?.SIDEBAR?.USER_REPORT || "User Report",
          path: '/dashboard/reportUserList',
          icon: <BugReportIcon sx={{ color: colorDemo }} />,
          for: ['ads'],
          urls: ['/dashboard/reportUserListForm', '/dashboard/editReportUserList']
        },
      ],
      for: ['ads']
    },
    {
      // title: "",
      optionTitle: i18?.SIDEBAR?.SETTINGS || "Settings",
      icon: <SettingsOutlinedIcon sx={{ color: colorDemo }} />,
      name: 'Settings',
      options: [
        {
          title: i18?.SIDEBAR?.APP_SETTING || "App Setting",
          path: '/dashboard/apps-settings',
          // icon: icon('ic_app'),
          icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
          urls: ['/dashboard/apps-settings']
        },
        {
          title: i18?.SIDEBAR?.PAYMENT_SETTING || "Payment Setting",
          path: '/dashboard/payment-settings',
          // icon: icon('ic_pay'),
          icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
          urls: ['/dashboard/payment-settings']
        },
        {
          title: i18?.SIDEBAR?.CURRENCY_SETTING || "Currency Setting",
          path: '/dashboard/currency-settings',
          // icon: icon('ic_currency'),
          icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
          urls: ['/dashboard/currency-settings'],
        },
        // {
        //   title: i18?.SIDEBAR?.GOOGLE_SETTING || "Google setting",
        //   path: '/dashboard/settings/?type=google',
        //   // icon: icon('ic_google'),
        //   icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
        // },
        // {
        //   title: i18?.SIDEBAR?.SITE_SETTINGS || "Site settings",
        //   path: '/dashboard/settings/?type=site',
        //   // icon: icon('ic_web'),
        //   icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
        // },
        {
          title: i18?.SIDEBAR?.SMTP_SETTINGS || "SMTP Settings ",
          path: '/dashboard/mailgateway-settings',
          // icon: icon('ic_smtp'),
          icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
          urls: ['/dashboard/mailgateway-settings']
        },
        // {
        //   title: i18?.SIDEBAR?.PWA_SETTINGS || "PWA Settings",
        //   path: '/dashboard/pwa-settings',
        //   icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
        //   urls: ['/dashboard/pwa-settings']
        // }
        // {
        //   title: i18?.SIDEBAR?.SOCIAL_SETTINGS || "Social Settings",
        //   path: '/dashboard/settings/?type=social',
        //   icon: <RadioButtonUncheckedIcon sx={{ color: colorDemo, fontSize: "10px" }} />,
        // },
      ],
    },
    {
      title: i18?.SIDEBAR?.EMAIL_TEMPLATE || "Email Template",
      path: '/dashboard/Template',
      // icon: icon('ic_email'),
      icon: <MarkunreadOutlinedIcon sx={{ color: colorDemo }} />,
      name: 'Email Template',
      urls: ['/dashboard/editemailTemplate', '/dashboard/editTemplate', '/dashboard/Template']
    },
    {
      title: i18?.SIDEBAR?.PUSH_NOTIFICATION_TEMPLATE || "PushNotification Template",
      path: '/dashboard/pushNotification',
      // icon: icon('ic_email'),
      icon: <DoorbellOutlined sx={{ color: colorDemo }} />,
      name:'Push Notification Template'
    },
    {
      title: i18?.SIDEBAR?.CMS || "CMS",
      path: '/dashboard/Cms',
      icon: <ArticleOutlinedIcon sx={{ color: colorDemo }} />,
      name: 'CMS',
      urls: ['/dashboard/EditcmsTemplate', '/dashboard/emailtemplate', '/dashboard/Cms']
    },
    {
      title: i18?.SIDEBAR?.HOW_DOES_IT_WORK || "How does it work",
      path: '/dashboard/how-does-work',
      // icon: icon('ic_email'),
      icon: <HelpOutlineOutlinedIcon sx={{ color: colorDemo }} />,
      name: 'How Does It Work',
      urls: ['/dashboard/how-does-work']
    },
  ], [i18]);

  const AdminProfileData = async () => {
    try {
      const res = await axios.get('module/auth/admin/profile');
      if (res.status === 200) {
        setApiData(res?.data?.data?.profileData?.role?.permission);
        // console.log("profiledata",res?.data?.data?.profileData.role.permission)
        // setImageUrl(res?.data?.data?.profileImage);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    AdminProfileData();
  }, []);
  console.log('apiData', apiData)

  const MappedNav = useMemo(() => {
    if (data?.hiddenSettings) {
      const allowedTypes = [];
      if (data.hiddenSettings?.ads === "1") {
        allowedTypes.push('ads')
      }
      if (data.hiddenSettings?.listing === "1" || allowedTypes.length === 0) {
        allowedTypes.push('listing')
      }

      return navConfig.filter((item) => { // filter based on types
        if (item?.for) {
          return item.for.some(arr => allowedTypes.includes(arr));
        }
        return true;
      }).filter((item) => { // filter main routes
        if (Array.isArray(item?.name)) {
          return item.name.some(value => myValue?.roles?.includes(value));

        }
        else if (item?.name) {
          return myValue?.roles?.includes(item.name);
        }
        return true;
      }).map((item) => { // filter sub routes
        // if (Array.isArray(item.options)) {
        //   item.options = item.options.filter((item) => {
        //     if (item?.for) {
        //       return item.for.some(arr => allowedTypes.includes(arr));
        //     }
        //     return true;
        //   })
        // }
        // // console.log("provider",item)

        // return item;

        if (Array.isArray(item.options)) {
        item.options = item.options.filter((sub) => {
          if (sub?.title) {
            const parent = apiData?.find((m) => m.menu === item.name);
            const subMenu = parent?.subMenuList?.find(
              (s) => s.menu === sub.title
            );
            return subMenu?.status !== false;
          }
          return true;
        });
      }
      return item;
      });
    }

    return [];
  }, [data, myValue, apiData, navConfig])

  return (
    <MyContext.Provider
      value={{
        data,
        logo,
        setLogo,
        favicon,
        setFavicon,
        myValue,
        setMyValue,
        imageUrl,
        setImageUrl,
        fetchProfileData,
        settingsData,
        demoMode,
        baseUrl,
        logoUrl,
        state,
        setState,
        i18,
        map,
        formatDate,
        specification,
        addition,
        documentsMode,
        propertyId,
        widgetId,
        adsMode,
        MappedNav,
        primaryTheme,
        secondaryTheme,
        getAvailableCount,
      }}
    >
      <Helmet>
        <link rel="icon" type="image/png" sizes="16x16" href={IMAGE_URL + favicon} />
      </Helmet>
      {children}
    </MyContext.Provider>
  );
};

export const useMyContext = () => {
  return useContext(MyContext);
};
